<script setup lang="ts">
import { FormInputCheckbox } from "../types";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const props = defineProps<{
  config: FormInputCheckbox;
  modelValue: boolean | boolean[] | string[] | number[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (
    e: "update:modelValue",
    value: boolean | boolean[] | string[] | number[],
  ): void;
}>();

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: boolean | boolean[] | string[] | number[]) =>
    emit("update:modelValue", value),
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
</script>

<template>
  <VCheckbox
    class="mt-5"
    v-model="value"
    v-bind="{ ...config, size: undefined }"
    :label="config.label ? $t(config.label) : undefined"
    :disabled="disabled || config.disabled"
  />
</template>
